// Deliberately allow one fixed internal destination; no arbitrary redirect URLs.
export const guideReturnPath = search => new URLSearchParams(search).get('returnTo') === '/guide-the-bot' ? '/guide-the-bot' : null;
